export const iconFontAwesomeMathematicsPercent = (
	<i className="fa-solid fa-percent"></i>
);
